// src/components/layout/LocBar.tsx
import React, { useEffect, useState } from "react";
import { View, Text, TouchableOpacity } from "react-native";
import { ChevronDown, MapPin, UserCircle2 } from "lucide-react-native";
import { homeStyles as styles } from "../shared/styles/homeStyles";
import { FlickOColors } from "../shared/styles/color";
import { useFocusEffect, useNavigation } from "@react-navigation/native";
import { getResponsiveSize } from "../shared/styles/globalStyles";
import { NavigationProps } from "../../types/navigation";
import { formatCamelCase } from "../shared/utils/formatters";
import { DefaultLocation, UserCreDB } from "../../types/user";

interface LocBarProps {
  title?: string;
  hideNav?: boolean;
  user?: UserCreDB | null;
  defaultLocation?: DefaultLocation | null;
}

export const LocBar = ({
  title,
  hideNav = false,
  user,
  defaultLocation,
}: LocBarProps) => {
  const navigation = useNavigation<NavigationProps>();

  const MAX_TOTAL_LENGTH = 45;

  // useFocusEffect(React.useCallback(() => {}, []));

  const maxAddress = (fullAddress: string): string => {
    return (
      fullAddress.slice(0, MAX_TOTAL_LENGTH) +
      (fullAddress.length > MAX_TOTAL_LENGTH ? "..." : "")
    );
  };

  return (
    <>
      <View style={styles.topBar}>
        {title && title?.length > 0 && (
          <Text style={{ fontSize: getResponsiveSize(24), fontWeight: "600" }}>
            {title}
          </Text>
        )}
        <TouchableOpacity
          onPress={() => {
            navigation.navigate("AddressSelectionScreen"); //claud
          }}
        >
          <View>
            <View
              style={{ flexDirection: "row", alignItems: "center", gap: 8 }}
            >
              <MapPin size={20} color={FlickOColors.primary} />
              <Text style={styles.locationTitle}>
                {user?.location && user.location.addresses
                  ? (() => {
                      // Ensure `user.location` is defined before accessing `currentId`
                      const currentAddress = user.location.addresses.find(
                        (addr) => addr[user.location?.currentId ?? ""]
                      )?.[user.location?.currentId ?? ""];

                      // Extract `addressName`, providing a default value if undefined
                      return currentAddress?.addressName || "No Address Found";
                    })()
                  : formatCamelCase(
                      defaultLocation?.addressName || "No Location Found"
                    )}
              </Text>
              <ChevronDown
                size={getResponsiveSize(20)}
                color={FlickOColors.primary}
              />
            </View>
            <Text style={styles.locationSubtitle}>
              {user?.location?.addresses
                ? (() => {
                    // Ensure `user.location` is defined before accessing `currentId`
                    const currentAddress = user.location.addresses.find(
                      (addr) => addr[user.location?.currentId ?? ""]
                    )?.[user.location?.currentId ?? ""];

                    // Extract locality and city, providing default values if undefined
                    const locality = currentAddress?.locality || "";
                    const city = currentAddress?.city || "";

                    // Concatenate locality and city
                    const fullAddress = `${locality}, ${city}`;

                    // Check if the full address exceeds the maximum length
                    return maxAddress(fullAddress);
                  })()
                : maxAddress(defaultLocation?.address || "")}
            </Text>
          </View>
        </TouchableOpacity>
        {!hideNav && (
          <TouchableOpacity onPress={() => navigation.navigate("Navigation")}>
            <UserCircle2
              size={getResponsiveSize(45)}
              color={FlickOColors.gray.dark}
            />
          </TouchableOpacity>
        )}
      </View>
    </>
  );
};
